module.exports = __webpack_public_path__ + "img/EDITABLE.8ac8e704.svg";